<template>
  <el-dialog
    :visible.sync="auditDialogShow"
    width="dialogContainer"
    :before-close="handleClose"
    class="customClass"
  >
    <div class="auditContent">
      <ModalContent
        :attributes="auditDialogData.changes.attributes ? auditDialogData.changes.attributes : null"
        :old="auditDialogData.changes.old ? auditDialogData.changes.old : null"
      />
    </div>
  </el-dialog>
</template>


<script>
import {mapGetters} from "vuex";
import ModalContent from "./ModalContent";

export default {
  name: 'AuditDialogModal',
  components: {ModalContent},
  computed: mapGetters({
    auditDialogShow: 'audit/audit/auditDialogShow',
    auditDialogData: 'audit/audit/auditDialogData',
  }),
  methods: {
    handleClose() {
      this.$store.dispatch('audit/audit/setAuditDialogShow', false);
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
@import 'AuditDialogModal.scss';

.customClass >>> .el-dialog__close {
  color: red !important;
  font-size: 24px;

}

</style>



// WEBPACK FOOTER //
// src/components/audit/ShowMore/AuditDialogModal.vue